import React, { Component } from 'react';

import { checkUndefine, formatMoney, formatNumber } from '../../../../../../../helpers/functions';

import {
    FormWrapperInputComponent,
} from "../../../../../common/component/Index";
import Wrapper from '../../../../../common/component/Wrapper';
import Input from '../../../../../common/component/Input';
import Span from '../../../../../common/component/Span';
import './DefaultPrice.less';

export default class DefaultPrice extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        const { t, tour, validation } = this.props;
        return (
            <Wrapper className="tour-detail-default-price row">
                <Span className="currencyUnit">{`${t('placeHolderForm.calculateUnit')}: ${t('currency')}`}</Span>
                <Wrapper className="col-md-12">
                    <FormWrapperInputComponent
                        typeInput={true}
                        classLabel="col-md-2"
                        classInputForm="col-md-10"
                        labelTitle={`${t(`item.tour.originalPrice`)}`}
                    >
                        <Wrapper className="col-md-12 row">
                            <Wrapper className="col-md-6">
                                <FormWrapperInputComponent
                                    isRequired={'right'}
                                    isValidation={true}
                                    dataValidation={tour.adultOriginalPrice}
                                    validation={validation.adultOriginalPrice}
                                    messageBelowInput={true}
                                    labelTitle={t(`item.tour.adultOriginalPrice`)}
                                >
                                    <Input placeholder="" type={`currency`}
                                        className={`form-control`}
                                        name={`adultOriginalPrice`} onChange={(e) => this.props.onChange('adultOriginalPrice', Number(e.target.value))}
                                        value={checkUndefine(tour.adultOriginalPrice)} />
                                </FormWrapperInputComponent>
                            </Wrapper>
                            <Wrapper className="col-md-6">
                                <FormWrapperInputComponent
                                    isValidation={true}
                                    dataValidation={tour.childOriginalPrice}
                                    validation={validation.childOriginalPrice}
                                    messageBelowInput={true}
                                    labelTitle={t(`item.tour.childOriginalPrice`)}
                                >
                                    <Input placeholder="" type={`currency`}
                                        className={`form-control`}
                                        name={`childOriginalPrice`} onChange={(e) => this.props.onChange('childOriginalPrice', Number(e.target.value))}
                                        value={checkUndefine(tour.childOriginalPrice)} />
                                </FormWrapperInputComponent>
                            </Wrapper>
                        </Wrapper>
                    </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-12">
                    <FormWrapperInputComponent
                        typeInput={true}
                        classLabel="col-md-2"
                        classInputForm="col-md-10"
                        labelTitle={`${t(`item.tour.salePrice`)}`}
                    >
                        <Wrapper className="col-md-12 row">
                            <Wrapper className="col-md-6">
                                <FormWrapperInputComponent
                                    isValidation={true}
                                    dataValidation={tour.adultSalePrice}
                                    validation={validation.adultSalePrice}
                                    messageBelowInput={true}
                                    labelTitle={t(`item.tour.adultSalePrice`)}
                                >
                                    <Input placeholder="" type={`currency`}
                                        className={`form-control`}
                                        name={`adultSalePrice`} onChange={(e) => this.props.onChange('adultSalePrice', Number(e.target.value))}
                                        value={checkUndefine(tour.adultSalePrice)} />
                                </FormWrapperInputComponent>
                            </Wrapper>
                            <Wrapper className="col-md-6">
                                <FormWrapperInputComponent
                                    isValidation={true}
                                    dataValidation={tour.childSalePrice}
                                    validation={validation.childSalePrice}
                                    messageBelowInput={true}
                                    labelTitle={t(`item.tour.childSalePrice`)}
                                >
                                    <Input placeholder="" type={`currency`}
                                        className={`form-control`}
                                        name={`childSalePrice`} onChange={(e) => this.props.onChange('childSalePrice', Number(e.target.value))}
                                        value={checkUndefine(tour.childSalePrice)} />
                                </FormWrapperInputComponent>
                            </Wrapper>
                        </Wrapper>
                    </FormWrapperInputComponent>
                </Wrapper>
            </Wrapper>
        )
    }


}

DefaultPrice.defaultProps = {
    onChange: (fieldName, value) => { },
}


